var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDineSvgrepo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 73.602 46.542",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.429,4.148c-0.743,0-1.344,0.598-1.344,1.338v8.018c0,1.084-0.807,1.988-1.854,2.14V5.937 c0-0.735-0.602-1.338-1.345-1.338c-0.744,0-1.345,0.603-1.345,1.338v9.707c-1.043-0.152-1.854-1.056-1.854-2.14V5.486 c0-0.74-0.601-1.338-1.343-1.338C0.604,4.148,0,4.746,0,5.486v8.018c0,2.563,2.012,4.669,4.543,4.835v21.749 c0,0.744,0.601,1.342,1.345,1.342c0.743,0,1.345-0.598,1.345-1.342V18.339c2.532-0.166,4.543-2.273,4.543-4.835V5.486 C11.775,4.746,11.175,4.148,10.429,4.148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.94,4.113c-2.329,0-2.154,4.669-2.154,10.426c0,3.801-0.076,7.126,0.542,8.948v16.601c0,0.744,0.601,1.342,1.344,1.342 c0.745,0,1.346-0.598,1.346-1.342V24.675c2.158-1.1,4.584-5.219,4.584-10.136C73.601,8.782,70.272,4.113,67.94,4.113z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.17,0C25.276,0,14.817,10.419,14.817,23.272c0,12.853,10.459,23.271,23.353,23.271 c12.901,0,23.359-10.418,23.359-23.271C61.529,10.419,51.071,0,38.17,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDineSvgrepo);
export default __webpack_public_path__ + "static/media/dine-svgrepo.8672d15dfade9c5becfb1abfb5e7fa09.svg";
export { ForwardRef as ReactComponent };